import { useQuery } from "@tanstack/react-query";
import { lookup } from "../types/lookupFilters";

type FetchFunction = (signal: AbortSignal) => Promise<lookup[]>;

export const useLookupQuery = (queryKey: string, fetchFn: FetchFunction, includeDefaultOption = true) => {
    const defaultLookup: lookup[] = [{ id: 0, description: "All" }];

    // queryKey ownership stays with the caller; fetchFn is an implementation detail of this wrapper.
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    return useQuery<lookup[], Error>({
        queryKey: [queryKey],
        queryFn: ({ signal }) => fetchFn(signal),
        select: (data) => includeDefaultOption ? [...defaultLookup, ...data] : data,
    });
};